module.exports = __webpack_public_path__ + "img/article_7_4.9d23e7fa.png";